import { ActionContext, ActionTree, GetterTree, MutationTree, Store } from "vuex";
import { RecentlyEditedManuscriptsClient } from "@/lib/clients";
import { RecentlyEditedManuscript } from "@/lib/models/recentlyEditedManuscript";

const recentlyEditedManuscriptsClient = new RecentlyEditedManuscriptsClient();

export interface RecentlyEditedManuscriptsState {
  items: RecentlyEditedManuscript[];
}

type Getters = {
  items(state: RecentlyEditedManuscriptsState): RecentlyEditedManuscript[];
};

const getters: GetterTree<RecentlyEditedManuscriptsState, {}> & Getters = {
  items: (state) => state.items,
};

type Mutations<S> = {
  setItems(state: S, payload: RecentlyEditedManuscript[]): void;
};

const mutations: MutationTree<RecentlyEditedManuscriptsState> & Mutations<RecentlyEditedManuscriptsState> = {
  setItems(state, payload) {
    return (state.items = payload);
  },
};

type Actions = {
  fetch: (
    this: Store<{}>,
    injectee: ActionContext<RecentlyEditedManuscriptsState, {}>,
    limit: number
  ) => Promise<void>;
};

const actions: ActionTree<RecentlyEditedManuscriptsState, {}> & Actions = {
  async fetch({ commit }, limit) {
    const items = await recentlyEditedManuscriptsClient.list({ limit });
    commit("setItems", items);
  },
};

export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters,
  actions,
  mutations,
};
